import api from './api';

// Busca todas as categorias (sem paginação)
export function fetchCategories() {
  return api.get('/categories');
}

// Busca categoria por ID
export function getCategoryById(id) {
  return api.get(`/categories/${id}`);
}

// Cria uma nova categoria (com suporte a useElastic)
export function createCategory(data, useElastic = false) {
  return api.post('/categories', data, {
    params: { useElastic }
  });
}

// Atualiza uma categoria existente
export function updateCategory(data, useElastic = false) {

  return api.put(`/categories/${data.categoryId}`, data, {
    params: { useElastic }
  });
}

// Exclui uma categoria por ID
export function deleteCategory(id, useElastic = false) {
  return api.delete(`/categories/${id}`, {
    params: { useElastic }
  });
}

// Exclui múltiplas categorias
export function deleteCategoriesBatch(ids, useElastic = false) {
  return api.delete('/categories', {
    params: { useElastic },
    data: ids
  });
}

// Busca paginada com filtro por nome
export function fetchCategoriesPaged(pageNumber, pageSize, search = '') {
  return api.get('/categories/paged', {
    params: {
      pageNumber,
      pageSize,
      search
    }
  });
}
